const exampleChecklist = [
  {
    _id: 1,
    title:
      "Example Airplane Malfunction Checklist (for example ONLY, not a real pilot's checklist)",
    steps: [
      {
        text: "Determine the type of malfunction",
        position: 1,
        _id: "df47c230-3726-4d93-9e7c-7171fb6c54da",
        conditions: {
          AND: [],
          IF: [],
          NAND: [],
          NOR: [
            "ee3f5f62-5088-4116-bc8e-ac72769171ca",
            "0d7fb065-fa8b-44b1-a095-2cc863837787",
            "47b5737b-9cd8-47ee-89b2-8bb4e91b77b0",
            "3b6e90a5-6fad-4226-9791-0763e9d8e0e8",
            "d126871d-351a-4d4e-b5c8-8d72dbbf0a54",
            "47b1b307-3a7a-4b24-a8dd-b979d119b6cc",
            "a4e9fb10-e719-4d7b-8f95-c46cdff51e97",
            "79f5e3b3-9f27-42cc-a62a-5c6abba3d996",
            "d05b599d-8368-4121-b065-e10f64158000",
            "21ae58dc-d719-4d31-955d-c5c832e048e2",
            "d9419531-477a-494d-aa38-f1fc30fd08e6",
            "cf37bcc0-9c93-497f-bff9-7840be957bb4",
            "e62f2119-40b8-4ba4-91f3-0e23e80be9e6",
            "b491103a-6b44-4594-8f19-d14ccb4c22be",
            "b853def4-ac38-42d5-92ba-9f616bdaa3bd",
            "a755ab54-be8d-466d-be92-cfb23b07d660",
          ],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Oil Temp problems",
        position: 2,
        _id: "53ef7229-f42b-4c7d-bf0c-966f512b96f8",
        conditions: {
          AND: [],
          IF: ["df47c230-3726-4d93-9e7c-7171fb6c54da"],
          NAND: [],
          NOR: [
            "0e3c996b-e583-49ea-85cf-20978481b139",
            "927f97c3-a12f-4d12-b744-846981005a44",
            "78c5130e-7780-4ebb-a4d9-ba923dc0d0b5",
            "39c379a0-d74f-4e27-b930-18921f3e6f84",
            "d9419531-477a-494d-aa38-f1fc30fd08e6",
            "cf37bcc0-9c93-497f-bff9-7840be957bb4",
            "b491103a-6b44-4594-8f19-d14ccb4c22be",
            "b853def4-ac38-42d5-92ba-9f616bdaa3bd",
            "a755ab54-be8d-466d-be92-cfb23b07d660",
          ],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Cylinder head problems",
        position: 3,
        _id: "78c5130e-7780-4ebb-a4d9-ba923dc0d0b5",
        conditions: {
          AND: [],
          IF: ["df47c230-3726-4d93-9e7c-7171fb6c54da"],
          NAND: [],
          NOR: [
            "0e3c996b-e583-49ea-85cf-20978481b139",
            "53ef7229-f42b-4c7d-bf0c-966f512b96f8",
            "927f97c3-a12f-4d12-b744-846981005a44",
            "39c379a0-d74f-4e27-b930-18921f3e6f84",
            "d9419531-477a-494d-aa38-f1fc30fd08e6",
            "cf37bcc0-9c93-497f-bff9-7840be957bb4",
            "b491103a-6b44-4594-8f19-d14ccb4c22be",
            "b853def4-ac38-42d5-92ba-9f616bdaa3bd",
            "a755ab54-be8d-466d-be92-cfb23b07d660",
          ],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Oil Pressure problems",
        position: 4,
        _id: "927f97c3-a12f-4d12-b744-846981005a44",
        conditions: {
          AND: [],
          IF: ["df47c230-3726-4d93-9e7c-7171fb6c54da"],
          NAND: [],
          NOR: [
            "39c379a0-d74f-4e27-b930-18921f3e6f84",
            "78c5130e-7780-4ebb-a4d9-ba923dc0d0b5",
            "53ef7229-f42b-4c7d-bf0c-966f512b96f8",
            "0e3c996b-e583-49ea-85cf-20978481b139",
            "d9419531-477a-494d-aa38-f1fc30fd08e6",
            "cf37bcc0-9c93-497f-bff9-7840be957bb4",
            "b491103a-6b44-4594-8f19-d14ccb4c22be",
            "b853def4-ac38-42d5-92ba-9f616bdaa3bd",
            "a755ab54-be8d-466d-be92-cfb23b07d660",
          ],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Manifold problems",
        position: 5,
        _id: "0e3c996b-e583-49ea-85cf-20978481b139",
        conditions: {
          AND: [],
          IF: ["df47c230-3726-4d93-9e7c-7171fb6c54da"],
          NAND: [],
          NOR: [
            "53ef7229-f42b-4c7d-bf0c-966f512b96f8",
            "927f97c3-a12f-4d12-b744-846981005a44",
            "78c5130e-7780-4ebb-a4d9-ba923dc0d0b5",
            "39c379a0-d74f-4e27-b930-18921f3e6f84",
            "d9419531-477a-494d-aa38-f1fc30fd08e6",
            "cf37bcc0-9c93-497f-bff9-7840be957bb4",
            "b491103a-6b44-4594-8f19-d14ccb4c22be",
            "b853def4-ac38-42d5-92ba-9f616bdaa3bd",
            "a755ab54-be8d-466d-be92-cfb23b07d660",
          ],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Rpm problems",
        position: 6,
        _id: "39c379a0-d74f-4e27-b930-18921f3e6f84",
        conditions: {
          AND: [],
          IF: ["df47c230-3726-4d93-9e7c-7171fb6c54da"],
          NAND: [],
          NOR: [
            "0e3c996b-e583-49ea-85cf-20978481b139",
            "53ef7229-f42b-4c7d-bf0c-966f512b96f8",
            "927f97c3-a12f-4d12-b744-846981005a44",
            "78c5130e-7780-4ebb-a4d9-ba923dc0d0b5",
            "d9419531-477a-494d-aa38-f1fc30fd08e6",
            "cf37bcc0-9c93-497f-bff9-7840be957bb4",
            "b491103a-6b44-4594-8f19-d14ccb4c22be",
            "b853def4-ac38-42d5-92ba-9f616bdaa3bd",
            "a755ab54-be8d-466d-be92-cfb23b07d660",
          ],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Loss of rpm during cruise flight (non-altitude engines)",
        position: 7,
        _id: "ee3f5f62-5088-4116-bc8e-ac72769171ca",
        conditions: {
          AND: [],
          IF: ["39c379a0-d74f-4e27-b930-18921f3e6f84"],
          NAND: [],
          NOR: [
            "b853def4-ac38-42d5-92ba-9f616bdaa3bd",
            "b491103a-6b44-4594-8f19-d14ccb4c22be",
            "e62f2119-40b8-4ba4-91f3-0e23e80be9e6",
            "cf37bcc0-9c93-497f-bff9-7840be957bb4",
            "d9419531-477a-494d-aa38-f1fc30fd08e6",
            "21ae58dc-d719-4d31-955d-c5c832e048e2",
            "d05b599d-8368-4121-b065-e10f64158000",
            "79f5e3b3-9f27-42cc-a62a-5c6abba3d996",
            "a4e9fb10-e719-4d7b-8f95-c46cdff51e97",
            "47b1b307-3a7a-4b24-a8dd-b979d119b6cc",
            "d126871d-351a-4d4e-b5c8-8d72dbbf0a54",
            "3b6e90a5-6fad-4226-9791-0763e9d8e0e8",
            "47b5737b-9cd8-47ee-89b2-8bb4e91b77b0",
            "0d7fb065-fa8b-44b1-a095-2cc863837787",
            "a755ab54-be8d-466d-be92-cfb23b07d660",
          ],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Loss of manifold pressure during cruise flight.",
        position: 8,
        _id: "0d7fb065-fa8b-44b1-a095-2cc863837787",
        conditions: {
          AND: [],
          IF: ["0e3c996b-e583-49ea-85cf-20978481b139"],
          NAND: [],
          NOR: [
            "ee3f5f62-5088-4116-bc8e-ac72769171ca",
            "47b5737b-9cd8-47ee-89b2-8bb4e91b77b0",
            "3b6e90a5-6fad-4226-9791-0763e9d8e0e8",
            "d126871d-351a-4d4e-b5c8-8d72dbbf0a54",
            "47b1b307-3a7a-4b24-a8dd-b979d119b6cc",
            "a4e9fb10-e719-4d7b-8f95-c46cdff51e97",
            "79f5e3b3-9f27-42cc-a62a-5c6abba3d996",
            "d05b599d-8368-4121-b065-e10f64158000",
            "21ae58dc-d719-4d31-955d-c5c832e048e2",
            "d9419531-477a-494d-aa38-f1fc30fd08e6",
            "cf37bcc0-9c93-497f-bff9-7840be957bb4",
            "e62f2119-40b8-4ba4-91f3-0e23e80be9e6",
            "b491103a-6b44-4594-8f19-d14ccb4c22be",
            "b853def4-ac38-42d5-92ba-9f616bdaa3bd",
            "a755ab54-be8d-466d-be92-cfb23b07d660",
          ],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Gain of manifold pressure during cruise flight.",
        position: 9,
        _id: "47b5737b-9cd8-47ee-89b2-8bb4e91b77b0",
        conditions: {
          AND: [],
          IF: ["0e3c996b-e583-49ea-85cf-20978481b139"],
          NAND: [],
          NOR: [
            "ee3f5f62-5088-4116-bc8e-ac72769171ca",
            "0d7fb065-fa8b-44b1-a095-2cc863837787",
            "3b6e90a5-6fad-4226-9791-0763e9d8e0e8",
            "d126871d-351a-4d4e-b5c8-8d72dbbf0a54",
            "47b1b307-3a7a-4b24-a8dd-b979d119b6cc",
            "a4e9fb10-e719-4d7b-8f95-c46cdff51e97",
            "79f5e3b3-9f27-42cc-a62a-5c6abba3d996",
            "d05b599d-8368-4121-b065-e10f64158000",
            "21ae58dc-d719-4d31-955d-c5c832e048e2",
            "d9419531-477a-494d-aa38-f1fc30fd08e6",
            "cf37bcc0-9c93-497f-bff9-7840be957bb4",
            "e62f2119-40b8-4ba4-91f3-0e23e80be9e6",
            "b491103a-6b44-4594-8f19-d14ccb4c22be",
            "b853def4-ac38-42d5-92ba-9f616bdaa3bd",
            "a755ab54-be8d-466d-be92-cfb23b07d660",
          ],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "High oil temperature.",
        position: 10,
        _id: "3b6e90a5-6fad-4226-9791-0763e9d8e0e8",
        conditions: {
          AND: [],
          IF: ["53ef7229-f42b-4c7d-bf0c-966f512b96f8"],
          NAND: [],
          NOR: [
            "ee3f5f62-5088-4116-bc8e-ac72769171ca",
            "0d7fb065-fa8b-44b1-a095-2cc863837787",
            "47b5737b-9cd8-47ee-89b2-8bb4e91b77b0",
            "d126871d-351a-4d4e-b5c8-8d72dbbf0a54",
            "47b1b307-3a7a-4b24-a8dd-b979d119b6cc",
            "a4e9fb10-e719-4d7b-8f95-c46cdff51e97",
            "79f5e3b3-9f27-42cc-a62a-5c6abba3d996",
            "d05b599d-8368-4121-b065-e10f64158000",
            "21ae58dc-d719-4d31-955d-c5c832e048e2",
            "d9419531-477a-494d-aa38-f1fc30fd08e6",
            "cf37bcc0-9c93-497f-bff9-7840be957bb4",
            "e62f2119-40b8-4ba4-91f3-0e23e80be9e6",
            "b491103a-6b44-4594-8f19-d14ccb4c22be",
            "b853def4-ac38-42d5-92ba-9f616bdaa3bd",
            "a755ab54-be8d-466d-be92-cfb23b07d660",
          ],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Low oil temperature",
        position: 11,
        _id: "d126871d-351a-4d4e-b5c8-8d72dbbf0a54",
        conditions: {
          AND: [],
          IF: ["53ef7229-f42b-4c7d-bf0c-966f512b96f8"],
          NAND: [],
          NOR: [
            "0d7fb065-fa8b-44b1-a095-2cc863837787",
            "ee3f5f62-5088-4116-bc8e-ac72769171ca",
            "47b5737b-9cd8-47ee-89b2-8bb4e91b77b0",
            "3b6e90a5-6fad-4226-9791-0763e9d8e0e8",
            "47b1b307-3a7a-4b24-a8dd-b979d119b6cc",
            "a4e9fb10-e719-4d7b-8f95-c46cdff51e97",
            "79f5e3b3-9f27-42cc-a62a-5c6abba3d996",
            "d05b599d-8368-4121-b065-e10f64158000",
            "21ae58dc-d719-4d31-955d-c5c832e048e2",
            "d9419531-477a-494d-aa38-f1fc30fd08e6",
            "cf37bcc0-9c93-497f-bff9-7840be957bb4",
            "e62f2119-40b8-4ba4-91f3-0e23e80be9e6",
            "b491103a-6b44-4594-8f19-d14ccb4c22be",
            "b853def4-ac38-42d5-92ba-9f616bdaa3bd",
            "a755ab54-be8d-466d-be92-cfb23b07d660",
          ],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "High oil pressure.",
        position: 12,
        _id: "47b1b307-3a7a-4b24-a8dd-b979d119b6cc",
        conditions: {
          AND: [],
          IF: ["927f97c3-a12f-4d12-b744-846981005a44"],
          NAND: [],
          NOR: [
            "ee3f5f62-5088-4116-bc8e-ac72769171ca",
            "0d7fb065-fa8b-44b1-a095-2cc863837787",
            "47b5737b-9cd8-47ee-89b2-8bb4e91b77b0",
            "3b6e90a5-6fad-4226-9791-0763e9d8e0e8",
            "d126871d-351a-4d4e-b5c8-8d72dbbf0a54",
            "a4e9fb10-e719-4d7b-8f95-c46cdff51e97",
            "79f5e3b3-9f27-42cc-a62a-5c6abba3d996",
            "d05b599d-8368-4121-b065-e10f64158000",
            "21ae58dc-d719-4d31-955d-c5c832e048e2",
            "d9419531-477a-494d-aa38-f1fc30fd08e6",
            "cf37bcc0-9c93-497f-bff9-7840be957bb4",
            "e62f2119-40b8-4ba4-91f3-0e23e80be9e6",
            "b491103a-6b44-4594-8f19-d14ccb4c22be",
            "b853def4-ac38-42d5-92ba-9f616bdaa3bd",
            "a755ab54-be8d-466d-be92-cfb23b07d660",
          ],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Low oil pressure.",
        position: 13,
        _id: "a4e9fb10-e719-4d7b-8f95-c46cdff51e97",
        conditions: {
          AND: [],
          IF: ["927f97c3-a12f-4d12-b744-846981005a44"],
          NAND: [],
          NOR: [
            "0d7fb065-fa8b-44b1-a095-2cc863837787",
            "47b5737b-9cd8-47ee-89b2-8bb4e91b77b0",
            "ee3f5f62-5088-4116-bc8e-ac72769171ca",
            "3b6e90a5-6fad-4226-9791-0763e9d8e0e8",
            "d126871d-351a-4d4e-b5c8-8d72dbbf0a54",
            "47b1b307-3a7a-4b24-a8dd-b979d119b6cc",
            "79f5e3b3-9f27-42cc-a62a-5c6abba3d996",
            "d05b599d-8368-4121-b065-e10f64158000",
            "21ae58dc-d719-4d31-955d-c5c832e048e2",
            "d9419531-477a-494d-aa38-f1fc30fd08e6",
            "cf37bcc0-9c93-497f-bff9-7840be957bb4",
            "b491103a-6b44-4594-8f19-d14ccb4c22be",
            "e62f2119-40b8-4ba4-91f3-0e23e80be9e6",
            "b853def4-ac38-42d5-92ba-9f616bdaa3bd",
            "a755ab54-be8d-466d-be92-cfb23b07d660",
          ],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Fluctuating oil pressure",
        position: 14,
        _id: "79f5e3b3-9f27-42cc-a62a-5c6abba3d996",
        conditions: {
          AND: [],
          IF: ["927f97c3-a12f-4d12-b744-846981005a44"],
          NAND: [],
          NOR: [
            "ee3f5f62-5088-4116-bc8e-ac72769171ca",
            "0d7fb065-fa8b-44b1-a095-2cc863837787",
            "47b5737b-9cd8-47ee-89b2-8bb4e91b77b0",
            "3b6e90a5-6fad-4226-9791-0763e9d8e0e8",
            "d126871d-351a-4d4e-b5c8-8d72dbbf0a54",
            "47b1b307-3a7a-4b24-a8dd-b979d119b6cc",
            "a4e9fb10-e719-4d7b-8f95-c46cdff51e97",
            "d05b599d-8368-4121-b065-e10f64158000",
            "21ae58dc-d719-4d31-955d-c5c832e048e2",
            "d9419531-477a-494d-aa38-f1fc30fd08e6",
            "cf37bcc0-9c93-497f-bff9-7840be957bb4",
            "e62f2119-40b8-4ba4-91f3-0e23e80be9e6",
            "b491103a-6b44-4594-8f19-d14ccb4c22be",
            "b853def4-ac38-42d5-92ba-9f616bdaa3bd",
            "a755ab54-be8d-466d-be92-cfb23b07d660",
          ],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "High cylinder head temperature.",
        position: 15,
        _id: "d05b599d-8368-4121-b065-e10f64158000",
        conditions: {
          AND: [],
          IF: ["78c5130e-7780-4ebb-a4d9-ba923dc0d0b5"],
          NAND: [],
          NOR: [
            "ee3f5f62-5088-4116-bc8e-ac72769171ca",
            "0d7fb065-fa8b-44b1-a095-2cc863837787",
            "47b5737b-9cd8-47ee-89b2-8bb4e91b77b0",
            "3b6e90a5-6fad-4226-9791-0763e9d8e0e8",
            "d126871d-351a-4d4e-b5c8-8d72dbbf0a54",
            "47b1b307-3a7a-4b24-a8dd-b979d119b6cc",
            "a4e9fb10-e719-4d7b-8f95-c46cdff51e97",
            "79f5e3b3-9f27-42cc-a62a-5c6abba3d996",
            "21ae58dc-d719-4d31-955d-c5c832e048e2",
            "d9419531-477a-494d-aa38-f1fc30fd08e6",
            "cf37bcc0-9c93-497f-bff9-7840be957bb4",
            "e62f2119-40b8-4ba4-91f3-0e23e80be9e6",
            "b491103a-6b44-4594-8f19-d14ccb4c22be",
            "b853def4-ac38-42d5-92ba-9f616bdaa3bd",
            "a755ab54-be8d-466d-be92-cfb23b07d660",
          ],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Low cylinder head temperature.",
        position: 16,
        _id: "21ae58dc-d719-4d31-955d-c5c832e048e2",
        conditions: {
          AND: [],
          IF: ["78c5130e-7780-4ebb-a4d9-ba923dc0d0b5"],
          NAND: [],
          NOR: [
            "0d7fb065-fa8b-44b1-a095-2cc863837787",
            "ee3f5f62-5088-4116-bc8e-ac72769171ca",
            "47b5737b-9cd8-47ee-89b2-8bb4e91b77b0",
            "3b6e90a5-6fad-4226-9791-0763e9d8e0e8",
            "d126871d-351a-4d4e-b5c8-8d72dbbf0a54",
            "47b1b307-3a7a-4b24-a8dd-b979d119b6cc",
            "a4e9fb10-e719-4d7b-8f95-c46cdff51e97",
            "79f5e3b3-9f27-42cc-a62a-5c6abba3d996",
            "d05b599d-8368-4121-b065-e10f64158000",
            "d9419531-477a-494d-aa38-f1fc30fd08e6",
            "cf37bcc0-9c93-497f-bff9-7840be957bb4",
            "e62f2119-40b8-4ba4-91f3-0e23e80be9e6",
            "b491103a-6b44-4594-8f19-d14ccb4c22be",
            "b853def4-ac38-42d5-92ba-9f616bdaa3bd",
            "a755ab54-be8d-466d-be92-cfb23b07d660",
          ],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Ammeter indicating discharge.",
        position: 17,
        _id: "d9419531-477a-494d-aa38-f1fc30fd08e6",
        conditions: {
          AND: [],
          IF: ["df47c230-3726-4d93-9e7c-7171fb6c54da"],
          NAND: [],
          NOR: [
            "ee3f5f62-5088-4116-bc8e-ac72769171ca",
            "0d7fb065-fa8b-44b1-a095-2cc863837787",
            "47b5737b-9cd8-47ee-89b2-8bb4e91b77b0",
            "3b6e90a5-6fad-4226-9791-0763e9d8e0e8",
            "d126871d-351a-4d4e-b5c8-8d72dbbf0a54",
            "a4e9fb10-e719-4d7b-8f95-c46cdff51e97",
            "47b1b307-3a7a-4b24-a8dd-b979d119b6cc",
            "79f5e3b3-9f27-42cc-a62a-5c6abba3d996",
            "d05b599d-8368-4121-b065-e10f64158000",
            "21ae58dc-d719-4d31-955d-c5c832e048e2",
            "cf37bcc0-9c93-497f-bff9-7840be957bb4",
            "e62f2119-40b8-4ba4-91f3-0e23e80be9e6",
            "b491103a-6b44-4594-8f19-d14ccb4c22be",
            "b853def4-ac38-42d5-92ba-9f616bdaa3bd",
            "a755ab54-be8d-466d-be92-cfb23b07d660",
            "53ef7229-f42b-4c7d-bf0c-966f512b96f8",
            "78c5130e-7780-4ebb-a4d9-ba923dc0d0b5",
            "927f97c3-a12f-4d12-b744-846981005a44",
            "0e3c996b-e583-49ea-85cf-20978481b139",
            "39c379a0-d74f-4e27-b930-18921f3e6f84",
          ],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Load meter indicating zero.",
        position: 18,
        _id: "cf37bcc0-9c93-497f-bff9-7840be957bb4",
        conditions: {
          AND: [],
          IF: ["df47c230-3726-4d93-9e7c-7171fb6c54da"],
          NAND: [],
          NOR: [
            "ee3f5f62-5088-4116-bc8e-ac72769171ca",
            "0d7fb065-fa8b-44b1-a095-2cc863837787",
            "47b5737b-9cd8-47ee-89b2-8bb4e91b77b0",
            "3b6e90a5-6fad-4226-9791-0763e9d8e0e8",
            "d126871d-351a-4d4e-b5c8-8d72dbbf0a54",
            "47b1b307-3a7a-4b24-a8dd-b979d119b6cc",
            "a4e9fb10-e719-4d7b-8f95-c46cdff51e97",
            "79f5e3b3-9f27-42cc-a62a-5c6abba3d996",
            "d05b599d-8368-4121-b065-e10f64158000",
            "21ae58dc-d719-4d31-955d-c5c832e048e2",
            "d9419531-477a-494d-aa38-f1fc30fd08e6",
            "e62f2119-40b8-4ba4-91f3-0e23e80be9e6",
            "b491103a-6b44-4594-8f19-d14ccb4c22be",
            "b853def4-ac38-42d5-92ba-9f616bdaa3bd",
            "a755ab54-be8d-466d-be92-cfb23b07d660",
            "53ef7229-f42b-4c7d-bf0c-966f512b96f8",
            "78c5130e-7780-4ebb-a4d9-ba923dc0d0b5",
            "927f97c3-a12f-4d12-b744-846981005a44",
            "0e3c996b-e583-49ea-85cf-20978481b139",
            "39c379a0-d74f-4e27-b930-18921f3e6f84",
          ],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Surging rpm and overspeeding.",
        position: 19,
        _id: "e62f2119-40b8-4ba4-91f3-0e23e80be9e6",
        conditions: {
          AND: [],
          IF: ["39c379a0-d74f-4e27-b930-18921f3e6f84"],
          NAND: [],
          NOR: [
            "ee3f5f62-5088-4116-bc8e-ac72769171ca",
            "0d7fb065-fa8b-44b1-a095-2cc863837787",
            "3b6e90a5-6fad-4226-9791-0763e9d8e0e8",
            "d126871d-351a-4d4e-b5c8-8d72dbbf0a54",
            "47b5737b-9cd8-47ee-89b2-8bb4e91b77b0",
            "47b1b307-3a7a-4b24-a8dd-b979d119b6cc",
            "a4e9fb10-e719-4d7b-8f95-c46cdff51e97",
            "79f5e3b3-9f27-42cc-a62a-5c6abba3d996",
            "d05b599d-8368-4121-b065-e10f64158000",
            "21ae58dc-d719-4d31-955d-c5c832e048e2",
            "d9419531-477a-494d-aa38-f1fc30fd08e6",
            "cf37bcc0-9c93-497f-bff9-7840be957bb4",
            "b491103a-6b44-4594-8f19-d14ccb4c22be",
            "b853def4-ac38-42d5-92ba-9f616bdaa3bd",
            "a755ab54-be8d-466d-be92-cfb23b07d660",
          ],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Loss of airspeed in cruise flight with manifold pressure and rpm constant.",
        position: 20,
        _id: "b491103a-6b44-4594-8f19-d14ccb4c22be",
        conditions: {
          AND: [],
          IF: ["df47c230-3726-4d93-9e7c-7171fb6c54da"],
          NAND: [],
          NOR: [
            "ee3f5f62-5088-4116-bc8e-ac72769171ca",
            "0d7fb065-fa8b-44b1-a095-2cc863837787",
            "47b5737b-9cd8-47ee-89b2-8bb4e91b77b0",
            "3b6e90a5-6fad-4226-9791-0763e9d8e0e8",
            "d126871d-351a-4d4e-b5c8-8d72dbbf0a54",
            "47b1b307-3a7a-4b24-a8dd-b979d119b6cc",
            "a4e9fb10-e719-4d7b-8f95-c46cdff51e97",
            "79f5e3b3-9f27-42cc-a62a-5c6abba3d996",
            "d05b599d-8368-4121-b065-e10f64158000",
            "21ae58dc-d719-4d31-955d-c5c832e048e2",
            "d9419531-477a-494d-aa38-f1fc30fd08e6",
            "cf37bcc0-9c93-497f-bff9-7840be957bb4",
            "e62f2119-40b8-4ba4-91f3-0e23e80be9e6",
            "b853def4-ac38-42d5-92ba-9f616bdaa3bd",
            "a755ab54-be8d-466d-be92-cfb23b07d660",
            "53ef7229-f42b-4c7d-bf0c-966f512b96f8",
            "78c5130e-7780-4ebb-a4d9-ba923dc0d0b5",
            "927f97c3-a12f-4d12-b744-846981005a44",
            "0e3c996b-e583-49ea-85cf-20978481b139",
            "39c379a0-d74f-4e27-b930-18921f3e6f84",
          ],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Rough running engine.",
        position: 21,
        _id: "b853def4-ac38-42d5-92ba-9f616bdaa3bd",
        conditions: {
          AND: [],
          IF: ["df47c230-3726-4d93-9e7c-7171fb6c54da"],
          NAND: [],
          NOR: [
            "ee3f5f62-5088-4116-bc8e-ac72769171ca",
            "0d7fb065-fa8b-44b1-a095-2cc863837787",
            "47b5737b-9cd8-47ee-89b2-8bb4e91b77b0",
            "3b6e90a5-6fad-4226-9791-0763e9d8e0e8",
            "d126871d-351a-4d4e-b5c8-8d72dbbf0a54",
            "47b1b307-3a7a-4b24-a8dd-b979d119b6cc",
            "a4e9fb10-e719-4d7b-8f95-c46cdff51e97",
            "79f5e3b3-9f27-42cc-a62a-5c6abba3d996",
            "d05b599d-8368-4121-b065-e10f64158000",
            "21ae58dc-d719-4d31-955d-c5c832e048e2",
            "cf37bcc0-9c93-497f-bff9-7840be957bb4",
            "d9419531-477a-494d-aa38-f1fc30fd08e6",
            "e62f2119-40b8-4ba4-91f3-0e23e80be9e6",
            "b491103a-6b44-4594-8f19-d14ccb4c22be",
            "a755ab54-be8d-466d-be92-cfb23b07d660",
            "53ef7229-f42b-4c7d-bf0c-966f512b96f8",
            "78c5130e-7780-4ebb-a4d9-ba923dc0d0b5",
            "927f97c3-a12f-4d12-b744-846981005a44",
            "0e3c996b-e583-49ea-85cf-20978481b139",
            "39c379a0-d74f-4e27-b930-18921f3e6f84",
          ],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Loss of fuel pressure.",
        position: 22,
        _id: "a755ab54-be8d-466d-be92-cfb23b07d660",
        conditions: {
          AND: [],
          IF: ["df47c230-3726-4d93-9e7c-7171fb6c54da"],
          NAND: [],
          NOR: [
            "ee3f5f62-5088-4116-bc8e-ac72769171ca",
            "0d7fb065-fa8b-44b1-a095-2cc863837787",
            "3b6e90a5-6fad-4226-9791-0763e9d8e0e8",
            "47b5737b-9cd8-47ee-89b2-8bb4e91b77b0",
            "d126871d-351a-4d4e-b5c8-8d72dbbf0a54",
            "47b1b307-3a7a-4b24-a8dd-b979d119b6cc",
            "a4e9fb10-e719-4d7b-8f95-c46cdff51e97",
            "79f5e3b3-9f27-42cc-a62a-5c6abba3d996",
            "d05b599d-8368-4121-b065-e10f64158000",
            "21ae58dc-d719-4d31-955d-c5c832e048e2",
            "d9419531-477a-494d-aa38-f1fc30fd08e6",
            "cf37bcc0-9c93-497f-bff9-7840be957bb4",
            "e62f2119-40b8-4ba4-91f3-0e23e80be9e6",
            "b491103a-6b44-4594-8f19-d14ccb4c22be",
            "b853def4-ac38-42d5-92ba-9f616bdaa3bd",
            "53ef7229-f42b-4c7d-bf0c-966f512b96f8",
            "78c5130e-7780-4ebb-a4d9-ba923dc0d0b5",
            "927f97c3-a12f-4d12-b744-846981005a44",
            "0e3c996b-e583-49ea-85cf-20978481b139",
            "39c379a0-d74f-4e27-b930-18921f3e6f84",
          ],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Carburetor or induction icing or air filter clogging.",
        position: 23,
        _id: "2dd7e188-9778-4b57-b328-ac1ea57de852",
        conditions: {
          AND: [],
          IF: [],
          NAND: [],
          NOR: [],
          NOT: ["2d5517fa-0e46-4387-8556-76db1220b720"],
          OR: [
            "ee3f5f62-5088-4116-bc8e-ac72769171ca",
            "0d7fb065-fa8b-44b1-a095-2cc863837787",
          ],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Turbocharger failure",
        position: 24,
        _id: "2d5517fa-0e46-4387-8556-76db1220b720",
        conditions: {
          AND: [],
          IF: ["0d7fb065-fa8b-44b1-a095-2cc863837787"],
          NAND: [],
          NOR: [],
          NOT: ["2dd7e188-9778-4b57-b328-ac1ea57de852"],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Throttle has opened, propeller controll has decreased rpm, or improper method of power reduction",
        position: 25,
        _id: "95e5a102-73cf-4a9f-a491-4dfa8515bc2a",
        conditions: {
          AND: [],
          IF: ["47b5737b-9cd8-47ee-89b2-8bb4e91b77b0"],
          NAND: [],
          NOR: [],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Oil congealed in cooler.",
        position: 26,
        _id: "03af553f-beff-4325-8cd5-15a936ba2db3",
        conditions: {
          AND: [],
          IF: ["3b6e90a5-6fad-4226-9791-0763e9d8e0e8"],
          NAND: [],
          NOR: [
            "e64804cd-db28-4bb4-b7d7-f1bac6126ece",
            "a3515f16-9eee-42ab-a700-787647aaae1e",
            "6b21d398-4f89-4fb0-b659-ba66fcc2ee03",
            "39e7a2b8-4748-44ba-8bbc-d1737419f25e",
          ],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Inadequate engine cooling",
        position: 27,
        _id: "e64804cd-db28-4bb4-b7d7-f1bac6126ece",
        conditions: {
          AND: [],
          IF: ["3b6e90a5-6fad-4226-9791-0763e9d8e0e8"],
          NAND: [],
          NOR: [
            "03af553f-beff-4325-8cd5-15a936ba2db3",
            "a3515f16-9eee-42ab-a700-787647aaae1e",
            "6b21d398-4f89-4fb0-b659-ba66fcc2ee03",
            "39e7a2b8-4748-44ba-8bbc-d1737419f25e",
          ],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Detonation or preignition",
        position: 28,
        _id: "a3515f16-9eee-42ab-a700-787647aaae1e",
        conditions: {
          AND: [],
          IF: [],
          NAND: [],
          NOR: [
            "03af553f-beff-4325-8cd5-15a936ba2db3",
            "e64804cd-db28-4bb4-b7d7-f1bac6126ece",
            "6b21d398-4f89-4fb0-b659-ba66fcc2ee03",
            "39e7a2b8-4748-44ba-8bbc-d1737419f25e",
            "fbdb90f6-d1fd-4c12-9fb7-69c236b24ca4",
            "a0c7a0d4-8ffc-48f1-a133-0156b05ecbdd",
          ],
          NOT: [],
          OR: [
            "3b6e90a5-6fad-4226-9791-0763e9d8e0e8",
            "d05b599d-8368-4121-b065-e10f64158000",
            "b853def4-ac38-42d5-92ba-9f616bdaa3bd",
          ],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Forthcoming internal engine failure.",
        position: 29,
        _id: "6b21d398-4f89-4fb0-b659-ba66fcc2ee03",
        conditions: {
          AND: [],
          IF: ["3b6e90a5-6fad-4226-9791-0763e9d8e0e8"],
          NAND: [],
          NOR: [
            "03af553f-beff-4325-8cd5-15a936ba2db3",
            "e64804cd-db28-4bb4-b7d7-f1bac6126ece",
            "a3515f16-9eee-42ab-a700-787647aaae1e",
            "39e7a2b8-4748-44ba-8bbc-d1737419f25e",
          ],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Defective thermostatic oil cooler control",
        position: 30,
        _id: "39e7a2b8-4748-44ba-8bbc-d1737419f25e",
        conditions: {
          AND: [],
          IF: ["3b6e90a5-6fad-4226-9791-0763e9d8e0e8"],
          NAND: [],
          NOR: [
            "03af553f-beff-4325-8cd5-15a936ba2db3",
            "e64804cd-db28-4bb4-b7d7-f1bac6126ece",
            "a3515f16-9eee-42ab-a700-787647aaae1e",
            "6b21d398-4f89-4fb0-b659-ba66fcc2ee03",
          ],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Engine not warmed up to operating temperature.",
        position: 31,
        _id: "8098aa70-5806-4b16-bb50-14608d03c9c2",
        conditions: {
          AND: [],
          IF: ["d126871d-351a-4d4e-b5c8-8d72dbbf0a54"],
          NAND: [],
          NOR: [],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Cold oil",
        position: 32,
        _id: "576c267f-c199-4288-8049-2df6e5da67de",
        conditions: {
          AND: [],
          IF: ["47b1b307-3a7a-4b24-a8dd-b979d119b6cc"],
          NAND: [],
          NOR: [],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Possible internal plugging",
        position: 33,
        _id: "337e0116-5458-4202-8fc0-fc3c944c76f5",
        conditions: {
          AND: [],
          IF: ["47b1b307-3a7a-4b24-a8dd-b979d119b6cc"],
          NAND: [],
          NOR: [],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Broken pressure relief valve.",
        position: 34,
        _id: "d616b914-d628-4236-bf6a-7543eaf00afc",
        conditions: {
          AND: [],
          IF: ["a4e9fb10-e719-4d7b-8f95-c46cdff51e97"],
          NAND: [],
          NOR: [],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Insufficient Oil",
        position: 35,
        _id: "e9a04091-3d09-4876-b6dc-9256e135f584",
        conditions: {
          AND: [],
          IF: ["a4e9fb10-e719-4d7b-8f95-c46cdff51e97"],
          NAND: [],
          NOR: [],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Burned out bearings. ",
        position: 36,
        _id: "3839b5a7-1cb9-4beb-8bc9-73a9856e82d4",
        conditions: {
          AND: [],
          IF: ["a4e9fb10-e719-4d7b-8f95-c46cdff51e97"],
          NAND: [],
          NOR: [],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Low oil supply, loose oil lines, defective pressure relief valve.",
        position: 37,
        _id: "1240ce20-c762-4cca-9d91-6d260c1ff30e",
        conditions: {
          AND: [],
          IF: ["79f5e3b3-9f27-42cc-a62a-5c6abba3d996"],
          NAND: [],
          NOR: [],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Improper cowl flap adjustment.",
        position: 38,
        _id: "fbdb90f6-d1fd-4c12-9fb7-69c236b24ca4",
        conditions: {
          AND: [],
          IF: ["d05b599d-8368-4121-b065-e10f64158000"],
          NAND: [],
          NOR: [
            "a3515f16-9eee-42ab-a700-787647aaae1e",
            "a0c7a0d4-8ffc-48f1-a133-0156b05ecbdd",
          ],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Insufficient airspeed for cooling",
        position: 39,
        _id: "3b70d778-ac12-4747-a634-dba2b7a8f787",
        conditions: {
          AND: [],
          IF: ["21ae58dc-d719-4d31-955d-c5c832e048e2"],
          NAND: [],
          NOR: [
            "0c355428-aa34-4e8a-8015-f0317e7394a4",
            "b7af3781-7c22-43a5-bf1c-a9fc3e902b46",
            "4f145efc-162b-4cce-b477-8266dc5ffd82",
          ],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Improper mixture adjustment",
        position: 40,
        _id: "a0c7a0d4-8ffc-48f1-a133-0156b05ecbdd",
        conditions: {
          AND: [],
          IF: ["d05b599d-8368-4121-b065-e10f64158000"],
          NAND: [],
          NOR: [
            "a3515f16-9eee-42ab-a700-787647aaae1e",
            "fbdb90f6-d1fd-4c12-9fb7-69c236b24ca4",
          ],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Excessive cowl flap opening.",
        position: 41,
        _id: "0c355428-aa34-4e8a-8015-f0317e7394a4",
        conditions: {
          AND: [],
          IF: ["21ae58dc-d719-4d31-955d-c5c832e048e2"],
          NAND: [],
          NOR: [
            "3b70d778-ac12-4747-a634-dba2b7a8f787",
            "b7af3781-7c22-43a5-bf1c-a9fc3e902b46",
            "4f145efc-162b-4cce-b477-8266dc5ffd82",
          ],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Excessively rich mixture",
        position: 42,
        _id: "b7af3781-7c22-43a5-bf1c-a9fc3e902b46",
        conditions: {
          AND: [],
          IF: ["21ae58dc-d719-4d31-955d-c5c832e048e2"],
          NAND: [],
          NOR: [
            "3b70d778-ac12-4747-a634-dba2b7a8f787",
            "0c355428-aa34-4e8a-8015-f0317e7394a4",
            "4f145efc-162b-4cce-b477-8266dc5ffd82",
          ],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Extended glides without clearing engine",
        position: 43,
        _id: "4f145efc-162b-4cce-b477-8266dc5ffd82",
        conditions: {
          AND: [],
          IF: ["21ae58dc-d719-4d31-955d-c5c832e048e2"],
          NAND: [],
          NOR: [
            "3b70d778-ac12-4747-a634-dba2b7a8f787",
            "0c355428-aa34-4e8a-8015-f0317e7394a4",
            "b7af3781-7c22-43a5-bf1c-a9fc3e902b46",
          ],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Alternator or generator failure.",
        position: 44,
        _id: "ed639316-409a-4f11-860c-97f7eb848199",
        conditions: {
          AND: [],
          IF: [],
          NAND: [],
          NOR: [],
          NOT: [],
          OR: [
            "d9419531-477a-494d-aa38-f1fc30fd08e6",
            "cf37bcc0-9c93-497f-bff9-7840be957bb4",
          ],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Defective propeller",
        position: 45,
        _id: "dd1414c9-1635-43f6-a4bf-0fb8d8bb88e7",
        conditions: {
          AND: [],
          IF: ["e62f2119-40b8-4ba4-91f3-0e23e80be9e6"],
          NAND: [],
          NOR: [],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Defective engine",
        position: 46,
        _id: "d8c19e6a-28e3-4655-80e1-01fbcbed21f4",
        conditions: {
          AND: [],
          IF: ["e62f2119-40b8-4ba4-91f3-0e23e80be9e6"],
          NAND: [],
          NOR: [],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Defective propeller governor.",
        position: 47,
        _id: "f2eb745e-64b5-43e3-9bbb-8d9ae30d8b50",
        conditions: {
          AND: [],
          IF: ["e62f2119-40b8-4ba4-91f3-0e23e80be9e6"],
          NAND: [],
          NOR: [],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Defective tachometer",
        position: 48,
        _id: "abc99cd4-7b3c-4fb1-a5a0-1c0b5ed4948e",
        conditions: {
          AND: [],
          IF: ["e62f2119-40b8-4ba4-91f3-0e23e80be9e6"],
          NAND: [],
          NOR: [],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Improper mixture setting",
        position: 49,
        _id: "b368aba8-f66e-4209-8125-faf96bdac7bf",
        conditions: {
          AND: [],
          IF: ["e62f2119-40b8-4ba4-91f3-0e23e80be9e6"],
          NAND: [],
          NOR: [],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Possible loss of one or more cylinders.",
        position: 50,
        _id: "47fa9229-5aee-4483-b811-f04cebfe30f5",
        conditions: {
          AND: [],
          IF: ["b491103a-6b44-4594-8f19-d14ccb4c22be"],
          NAND: [],
          NOR: [],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Improper mixture control setting",
        position: 51,
        _id: "c3c47ec6-dfa5-4363-8cce-c7becd6abfd2",
        conditions: {
          AND: [],
          IF: ["b853def4-ac38-42d5-92ba-9f616bdaa3bd"],
          NAND: [],
          NOR: [],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Defective ignition or valves",
        position: 52,
        _id: "9ad5fcec-a5c8-4cba-aab4-acb0b1baa1ed",
        conditions: {
          AND: [],
          IF: ["b853def4-ac38-42d5-92ba-9f616bdaa3bd"],
          NAND: [],
          NOR: [],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Induction air leak",
        position: 53,
        _id: "4be77963-4e2a-483f-9030-5c9de9c31bd9",
        conditions: {
          AND: [],
          IF: ["b853def4-ac38-42d5-92ba-9f616bdaa3bd"],
          NAND: [],
          NOR: [],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Plugged fuel nozzle(fuel injection)",
        position: 54,
        _id: "eb8fd9b9-cb5e-43ca-a46b-b20dfe11b507",
        conditions: {
          AND: [],
          IF: ["b853def4-ac38-42d5-92ba-9f616bdaa3bd"],
          NAND: [],
          NOR: [],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Excessive fuel pressure or fuel flow.",
        position: 55,
        _id: "d0ab361c-fafa-4691-917c-ed46593be0ea",
        conditions: {
          AND: [],
          IF: ["b853def4-ac38-42d5-92ba-9f616bdaa3bd"],
          NAND: [],
          NOR: [],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Engine-driven pump failure No fuel.",
        position: 56,
        _id: "f355a0b7-9085-4a52-94de-97b27cd105a7",
        conditions: {
          AND: [],
          IF: ["a755ab54-be8d-466d-be92-cfb23b07d660"],
          NAND: [],
          NOR: [],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Apply carburetor heat, If dirty filter is suspected and non-filtered air is available, switch selector to unfiltered position",
        position: 57,
        _id: "a82ce982-1c66-49fc-8457-7b1fe3f2f0c5",
        conditions: {
          AND: [],
          IF: ["2dd7e188-9778-4b57-b328-ac1ea57de852"],
          NAND: [],
          NOR: [],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Possible exhaust leak. Shut down engine or use lowest practicable power setting. Land as soon as possible.",
        position: 58,
        _id: "c6244cb6-7a18-4b63-b761-07f5098941e1",
        conditions: {
          AND: [],
          IF: ["2d5517fa-0e46-4387-8556-76db1220b720"],
          NAND: [],
          NOR: [],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Readjust throttle and tighten friction lock. Reduce manifold pressure prior to reducing rpm.",
        position: 59,
        _id: "06ef5ab5-6f1b-4904-92fa-70bd7ea2203a",
        conditions: {
          AND: [],
          IF: ["95e5a102-73cf-4a9f-a491-4dfa8515bc2a"],
          NAND: [],
          NOR: [],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Reduce power. Land. Preheat engine.",
        position: 60,
        _id: "ba8197d2-9128-4de6-92ea-4684298f43ff",
        conditions: {
          AND: [],
          IF: ["03af553f-beff-4325-8cd5-15a936ba2db3"],
          NAND: [],
          NOR: [],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Reduce power. Increase airspeed.",
        position: 61,
        _id: "8b5cdd34-a52a-4130-b5eb-3d501a5f03c0",
        conditions: {
          AND: [],
          IF: ["e64804cd-db28-4bb4-b7d7-f1bac6126ece"],
          NAND: [],
          NOR: [],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Observe cylinder head temperatures for high reading. Reduce manifold pressure. Enrich mixture.",
        position: 62,
        _id: "4e8f3975-64d1-49f2-849b-f9fdb7517002",
        conditions: {
          AND: [
            "a3515f16-9eee-42ab-a700-787647aaae1e",
            "3b6e90a5-6fad-4226-9791-0763e9d8e0e8",
          ],
          IF: [],
          NAND: [],
          NOR: [],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Land as soon as possible or feather propeller and stop engine.",
        position: 63,
        _id: "b088de16-2fdf-424a-bf91-2f1a58f961bf",
        conditions: {
          AND: [],
          IF: [],
          NAND: [],
          NOR: [],
          NOT: [],
          OR: [
            "6b21d398-4f89-4fb0-b659-ba66fcc2ee03",
            "d616b914-d628-4236-bf6a-7543eaf00afc",
            "e9a04091-3d09-4876-b6dc-9256e135f584",
            "3839b5a7-1cb9-4beb-8bc9-73a9856e82d4",
            "1240ce20-c762-4cca-9d91-6d260c1ff30e",
          ],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Land as soon as possible. Consult maintenance personnel.",
        position: 64,
        _id: "af678df5-c579-401d-b8ae-faf0161c19bb",
        conditions: {
          AND: [],
          IF: ["39e7a2b8-4748-44ba-8bbc-d1737419f25e"],
          NAND: [],
          NOR: [],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Warm engine in prescribed manner.",
        position: 65,
        _id: "b2195751-a60d-4c21-b7c4-e8fb4a766205",
        conditions: {
          AND: [],
          IF: [],
          NAND: [],
          NOR: [],
          NOT: [],
          OR: [
            "8098aa70-5806-4b16-bb50-14608d03c9c2",
            "576c267f-c199-4288-8049-2df6e5da67de",
          ],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Adjust cowl flaps.",
        position: 66,
        _id: "60ffee74-81df-4cff-9064-6ad34019eb51",
        conditions: {
          AND: [],
          IF: [],
          NAND: [],
          NOR: [],
          NOT: [],
          OR: [
            "fbdb90f6-d1fd-4c12-9fb7-69c236b24ca4",
            "0c355428-aa34-4e8a-8015-f0317e7394a4",
          ],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Adjust mixture control.",
        position: 67,
        _id: "84c1a7a3-eff5-481c-abe9-c9300d35fc3d",
        conditions: {
          AND: [],
          IF: ["b7af3781-7c22-43a5-bf1c-a9fc3e902b46"],
          NAND: [],
          NOR: [],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Clear engine long enough to keep temps at minimum range",
        position: 68,
        _id: "b1052571-aed2-4d64-a60c-63dcf5fa4071",
        conditions: {
          AND: [],
          IF: ["4f145efc-162b-4cce-b477-8266dc5ffd82"],
          NAND: [],
          NOR: [],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Shed unnecessary electrical load. Land as soon as practicable.",
        position: 69,
        _id: "867e4635-5d6f-445c-9920-fadeb05af272",
        conditions: {
          AND: [],
          IF: ["ed639316-409a-4f11-860c-97f7eb848199"],
          NAND: [],
          NOR: [],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Adjust propeller rpm",
        position: 70,
        _id: "523e15aa-ffad-4fb4-a9ac-54e752e26469",
        conditions: {
          AND: [],
          IF: ["dd1414c9-1635-43f6-a4bf-0fb8d8bb88e7"],
          NAND: [],
          NOR: [],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Consult maintenance",
        position: 71,
        _id: "65d8c8f2-295a-41f2-8004-0e7afb71e77f",
        conditions: {
          AND: [],
          IF: [],
          NAND: [],
          NOR: [],
          NOT: [],
          OR: [
            "d8c19e6a-28e3-4655-80e1-01fbcbed21f4",
            "abc99cd4-7b3c-4fb1-a5a0-1c0b5ed4948e",
          ],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Adjust propeller control. Attempt to restore normal operation",
        position: 72,
        _id: "2cbb99a4-2c58-4618-ac75-bf9b4fef13a9",
        conditions: {
          AND: [],
          IF: ["f2eb745e-64b5-43e3-9bbb-8d9ae30d8b50"],
          NAND: [],
          NOR: [],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Readjust mixture for smmooth operation.",
        position: 73,
        _id: "88e01bbe-067d-414e-bfe4-ae2be6a50753",
        conditions: {
          AND: [],
          IF: ["a0c7a0d4-8ffc-48f1-a133-0156b05ecbdd"],
          NAND: [],
          NOR: [],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Land as soon as possible",
        position: 74,
        _id: "1110877b-9d85-43eb-adec-b1e389ca718b",
        conditions: {
          AND: [],
          IF: ["47fa9229-5aee-4483-b811-f04cebfe30f5"],
          NAND: [],
          NOR: [],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Adjust mixture for smooth operation",
        position: 75,
        _id: "24e9e476-fead-4125-b236-966afea575bf",
        conditions: {
          AND: [],
          IF: ["c3c47ec6-dfa5-4363-8cce-c7becd6abfd2"],
          NAND: [],
          NOR: [],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Consult maintenance personnel",
        position: 76,
        _id: "eb3ea33a-cdba-4eaf-aa7a-be786a6d4d1a",
        conditions: {
          AND: [],
          IF: ["9ad5fcec-a5c8-4cba-aab4-acb0b1baa1ed"],
          NAND: [],
          NOR: [],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Reduce power, enrich mixture, open cowl flaps to reduce cylinder head temp. Land as soon as possible.",
        position: 77,
        _id: "95762d96-5c95-4377-a546-b422618bf9ae",
        conditions: {
          AND: [
            "a3515f16-9eee-42ab-a700-787647aaae1e",
            "b853def4-ac38-42d5-92ba-9f616bdaa3bd",
          ],
          IF: [],
          NAND: [],
          NOR: [],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Reduce power Consult maintenance.",
        position: 78,
        _id: "f23ce2db-830f-4268-84c2-2f4639613380",
        conditions: {
          AND: [],
          IF: ["4be77963-4e2a-483f-9030-5c9de9c31bd9"],
          NAND: [],
          NOR: [],
          NOT: [],
          OR: [
            "4be77963-4e2a-483f-9030-5c9de9c31bd9",
            "eb8fd9b9-cb5e-43ca-a46b-b20dfe11b507",
          ],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Lean mixture control",
        position: 79,
        _id: "d11fe7fb-a352-46b8-84ad-0a701ab36e74",
        conditions: {
          AND: [],
          IF: ["d0ab361c-fafa-4691-917c-ed46593be0ea"],
          NAND: [],
          NOR: [],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Turn on boost pumps. Switch tanks, turn on fuel.",
        position: 80,
        _id: "039d4d89-767f-40ba-ae63-e916c0cfcf34",
        conditions: {
          AND: [],
          IF: ["f355a0b7-9085-4a52-94de-97b27cd105a7"],
          NAND: [],
          NOR: [],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
      {
        text: "Reduce power. enrich mixture, increase cooling airflow",
        position: 81,
        _id: "03bb2030-d813-4691-8c4d-73dc8836e693",
        conditions: {
          AND: [
            "a3515f16-9eee-42ab-a700-787647aaae1e",
            "d05b599d-8368-4121-b065-e10f64158000",
          ],
          IF: [],
          NAND: [],
          NOR: [],
          NOT: [],
          OR: [],
          XNOR: [],
          XOR: [],
        },
      },
    ],
  },
];

export default exampleChecklist;
